import EditableDatePicker from 'components/forms/editableDatePicker';
import events from 'lib/events';
import moment from 'moment';
import React from 'react';
import ReportDropDown from '../../components/reportDropDown';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {reportDateFormat, dateTimeFormats} from 'helpers/constants';

class OutboundEmailsOptions extends React.Component {
  state = {
  };

  componentWillMount() {
    this.resetFilters();
  }

  resetFilters = () => {
    let filters = this.props.defaultFilters;

    this.setState({
      dateFrom: filters.dateFrom,
      dateTo: filters.dateTo,
      store: filters.store,
    });
  };

  updateData = () => {
    this.props.updateReportData(
			moment(this.state.dateFrom).format(dateTimeFormats.numeralDate),
			moment(this.state.dateTo).format(dateTimeFormats.numeralDate),
			this.state.store,
		);
  };

  updateDates = data => {
    if(data.key === 'dateFrom') {
      if(this.validateDates(data.value, this.state.dateTo)) {
        this.setState({
          dateFrom: data.value,
        });
      }
    } else if(data.key === 'dateTo') {
      if(this.validateDates(this.state.dateFrom, data.value)) {
        this.setState({
          dateTo: data.value,
        });
      }
    }
  };
  resetFilters = () =>{
    let filters = this.props.defaultFilters;

    this.setState({
      dateFrom: filters.dateFrom,
      dateTo: filters.dateTo,
      store: filters.store,
    });
  };

  validateDates = (dateFrom, dateTo) => {
    if(moment(dateFrom).isAfter(dateTo)) {
      let {formatMessage} = this.props.intl;

      events.publish('error.user', {
        message: formatMessage({id: 'general.error.invalid.dates'}),
        key: 'invalidDates',
      });
      return false;
    }
    return true;
  };

  render() {

    let stores = [];
    let {formatMessage} = this.props.intl;

    if(this.props.branches != null && this.props.branches.length > 0) {
      var obj = this.props.branches;

      stores = Object.keys(obj).map(function(key) {
        return {value: obj[key].id, label: obj[key].name};
      });

      stores.unshift({value: 0, label: formatMessage({id: 'general.all.stores'})});
    }

    return <div className="report-options">
      <div className="top-title-bar">
        <FormattedMessage id="general.report.options"/>
      </div>
      <div className="select-options container-fluid">
        <div className="row">
          <div className="col-sm-3">
            <div className='form-group'>
              <label><FormattedMessage id="general.date.from"/></label>
              <EditableDatePicker
                onChange={this.updateDates}
                dataKey='dateFrom'
                value={this.state.dateFrom}
                maxDate={moment(this.state.dateTo).clone().subtract(1, 'days')}
                editMode={true}
                dateFormat={reportDateFormat}/>
            </div>
          </div>
          <div className="col-sm-3">
            <div className='form-group'>
              <label><FormattedMessage id="general.date.to"/></label>
              <EditableDatePicker
                onChange={this.updateDates}
                dataKey='dateTo'
                value={this.state.dateTo}
                editMode={true}
                minDate={moment(this.state.dateFrom).clone()}
                maxDate={moment()}
                dateFormat={reportDateFormat}/>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-3">
            <ReportDropDown value={this.state.store}
                            label={formatMessage({id: 'general.store'})}
                            onChange={e => {
                              this.setState({store: e.target.value});
                            }}
                            options={stores}/>
          </div>
        </div>
      </div>
      <div className="manage-options">
        <div className="col-sm-12 button-group">
          <a className="reset-button pull-right"
             onClick={this.resetFilters}><FormattedMessage id="general.reset"/></a>
          <a className="btn btn-primary pull-right"
             onClick={this.updateData}><FormattedMessage id="reports.update.summary"/></a>
        </div>
      </div>
    </div>;
  }
}

export default injectIntl(OutboundEmailsOptions);
